import { gql } from "@apollo/client";
import useWrappedQuery from "../../common/data-fetching/useWrappedQuery.js";

const QUERY_SCOPE = "job";
const QUERY_NAME = "jobCountsByStatus";

export const QUERY = gql`
  query ${QUERY_SCOPE}_${QUERY_NAME}($employerId: ID) {
    ${QUERY_SCOPE} {
      _id
      ${QUERY_NAME}(employerId: $employerId) {
        _id
        status
        count
      }
    }
  }
`;

export default function useQueryJobCountsByStatus(employerId) {
  const variables = { employerId};

  return useWrappedQuery(QUERY, QUERY_SCOPE, QUERY_NAME,{
    variables,
    // Get info from cache and ask the network at the same time, then update on response
    fetchPolicy: "cache-and-network",
  });
}
